import React, { useState } from "react";

import {
  useTranslate,
  useTitle,
  CanAccess,
  ITreeMenu,
  useRefineContext,
  useRouterContext,
} from "@pankod/refine-core";
import { AntdLayout, Menu, Grid, Icons, useMenu, Modal, useModal } from "@pankod/refine-antd";
import { antLayoutSider, antLayoutSiderMobile } from "./styles";
import { useTranslation } from "react-i18next";
import { UnorderedListOutlined, UserSwitchOutlined, AreaChartOutlined, CalendarOutlined, CarryOutOutlined, EuroOutlined, CodeSandboxOutlined, DesktopOutlined, LogoutOutlined, TeamOutlined, UserOutlined, CoffeeOutlined, CrownOutlined, BankOutlined, BlockOutlined, ExclamationCircleOutlined, SolutionOutlined, HddOutlined, ExperimentOutlined, SettingOutlined } from "@ant-design/icons"
import { authProvider } from "authProvider";

export const Sider: React.FC = () => {
  // const { t, i18n } = useTranslation();
  const [collapsed, setCollapsed] = useState<boolean>(true);

  const { Link } = useRouterContext();
  const { hasDashboard } = useRefineContext();
  const Title = useTitle();
  const { SubMenu } = Menu;

  const t = useTranslate();
  const { menuItems, selectedKey, defaultOpenKeys } = useMenu();
  const breakpoint = Grid.useBreakpoint();

  const { modalProps, show } = useModal();

  const listMenuItem: any[] = [
    {
      label: t("menu.pricezones"),
      name: t("menu.pricezones"),
      route: encodeURI(t("menu.pricezones")),
      icon: <EuroOutlined />,
      parentName: undefined,
      customsroutes: [t("menu.yield")],
      children: [],
    },
    {
      label: t("menu.rooms"),
      name: t("menu.rooms"),
      route: encodeURI(t("menu.rooms")),
      icon: <BankOutlined />,
      children: [],
      parentName: undefined,
      customsroutes: [],
    },
    {
      label: t("menu.agendas"),
      name: t("menu.agendas"),
      route: encodeURI(t("menu.agendas")),
      icon: <CalendarOutlined />,

      children: [],
      parentName: undefined,
      customsroutes: [],
    },
    {
      label: t("menu.events"),
      name: t("menu.events"),
      route: encodeURI(t("menu.events")),
      icon: <CarryOutOutlined />,
      children: [],
      parentName: undefined,
      customsroutes: [],
    },
    {
      label: t("menu.users"),
      name: t("menu.users"),
      route: encodeURI(t("menu.users")),
      icon: <TeamOutlined />,
      children: [],
      parentName: undefined,
      customsroutes: [],
    },
  ]


  const isMobile =
    typeof breakpoint.lg === "undefined" ? false : !breakpoint.lg;

  const renderTreeView = (tree: ITreeMenu[], selectedKey: string) => {
    return tree.map((item: any) => {
      const { icon, label, route, name, children, parentName, customsroutes } = item;

      if (children.length > 0) {
        return (
          <SubMenu
            key={`SubMenu_${route}`}
            icon={icon ?? <UnorderedListOutlined />}
            title={label}
          >
            {renderTreeView(children, selectedKey)}
          </SubMenu>
        );
      }
      const isSelected = `/${route}` === selectedKey || customsroutes.some((e: string) => `/${e}` === selectedKey);
      const isRoute = !(parentName !== undefined && children.length === 0);
      return (
        <CanAccess key={route} resource={name.toLowerCase()} action="list">
          <Menu.Item
            key={`Menu.Item$_${route}`}
            style={{
              fontWeight: isSelected ? "bold" : "normal",
            }}
            icon={icon ?? (isRoute && <UnorderedListOutlined />)}
          >
            <Link to={route}>{label}</Link>
            {!collapsed && isSelected && (
              <div className="ant-menu-tree-arrow" />
            )}
          </Menu.Item>
        </CanAccess>
      );
    });
  };

  return (
    <AntdLayout.Sider
      collapsible
      collapsed={collapsed}
      onCollapse={(collapsed: boolean): void => setCollapsed(collapsed)}
      collapsedWidth={isMobile ? 0 : 80}
      style={isMobile ? antLayoutSiderMobile : antLayoutSider}
      key='Sider'
    >
      {Title && <Title collapsed={collapsed} />}
      <Menu
        selectedKeys={[selectedKey]}
        defaultOpenKeys={defaultOpenKeys}
        mode="inline"
        onClick={() => {
          if (!breakpoint.lg) {
            setCollapsed(true);
          }
        }}
      >
        {hasDashboard && (
          <Menu.Item
            key="dashboard"
            style={{
              fontWeight: selectedKey === "/" ? "bold" : "normal",
            }}
            icon={<Icons.DashboardOutlined />}
          >
            <Link to="/">{t("dashboard.title", "Dashboard")}</Link>
            {!collapsed && selectedKey === "/" && (
              <div className="ant-menu-tree-arrow" />
            )}
          </Menu.Item>
        )}

        {renderTreeView(listMenuItem, selectedKey)}
        <Menu.Item key="logout" onClick={show} icon={<LogoutOutlined />}>
          {t("buttons.logout", "Logout")}
        </Menu.Item>
      </Menu>
      <Modal onOk={() => authProvider.logout({})} cancelText={t("buttons.cancel")} okText={t("buttons.confirm")} {...modalProps}>
        <ExclamationCircleOutlined style={{ "color": "red" }} /><br />
        {t("buttons.logout", "Logout")}
      </Modal>
    </AntdLayout.Sider>
  );
};
